import type { ReactElement } from 'react'

import { useNumberFormat } from '../../../../../utils/hooks/storefront-intl'

type Props = {
  percentage: number
  color?: string
  radius?: number
  strokeWidth?: number
}

export default function ProgressRing(props: Readonly<Props>): ReactElement {
  const { percentage, color = 'white', radius = 30, strokeWidth = 4 } = props

  const formatter = useNumberFormat({ style: 'percent' })
  const percentageDisplay = formatter.format(percentage / 100)

  const circumference = radius * 2 * Math.PI
  const offset = circumference - (percentage / 100) * circumference

  return (
    <svg className="dali-plugin-imagegallery-progress-ring" width="90" height="90">
      <circle
        className="dali-plugin-imagegallery-progress-ring-background"
        fill="none"
        stroke="grey"
        strokeWidth={strokeWidth}
        r={radius}
        cx="45"
        cy="45"
      />
      <circle
        className="dali-plugin-imagegallery-progress-ring-front"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference + ' ' + circumference}
        strokeDashoffset={offset}
        r={radius}
        cx="45"
        cy="45"
      />
      <text x="50%" y="50%" dy="5" fill={color} textAnchor="middle">
        {percentageDisplay}
      </text>
    </svg>
  )
}
